import { EntityService } from '../../service/EntityService';

export class PaymentLogService extends EntityService {

  static entity = 'app/payment-log';

}
